import { RouteModule } from '#/horizon/components/RouteModule';
import { useI18n } from '#/i18n/hooks/useI18n';
import type { HorizonAppRouteLoaderArgs } from '#/routing/classes/types/AppRouteLoaderArgs';
import { movementRoute } from '#/routing/routes';
import type { HorizonAppRouteComponentProps } from '#/routing/types/HorizonAppRouteComponentProps';

import { MovementPage } from './MovementPage';

export function loader(_: HorizonAppRouteLoaderArgs<typeof movementRoute>) {}

export default function MovementHorizonRoute(
  _: HorizonAppRouteComponentProps<typeof loader>,
) {
  const { i18n } = useI18n();

  return (
    <RouteModule
      title={i18n('Interest Form')}
      linkRels={{ canonical: movementRoute.with({}) }}
    >
      <MovementPage />
    </RouteModule>
  );
}
